// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import ladEntity from './entities/lad.json';
import ladMenu from '../pages/lad/menu.json';
import ladFullForm from '../pages/lad/forms/full.json';
import ladContextForm from '../pages/lad/forms/context.json';
import ladMiniForm from '../pages/lad/forms/mini.json';
import ladLookupForm from '../pages/lad/forms/lookup.json';
import ladTableView from '../pages/lad/views/table.json';
import ladStagesView from '../pages/lad/views/stages.json';
import ladCardsView from '../pages/lad/views/cards.json';
import ladInlineView from '../pages/lad/views/inline.json';
import ladBacklogView from '../pages/lad/views/backlog.json';
import ladSplitView from '../pages/lad/views/split.json';
import ladCalendarView from '../pages/lad/views/calendar.json';
import ladDashboardView from '../pages/lad/views/dashboard.json';

/** Тип запису «Питання» зі сторінками пакета: меню, форми та подання з pages/lad/. */
export const ladDefinition: IRecordTypeDefinition = {
  ...ladEntity,
  views: assembleViewSet({
      table: ladTableView,
      stages: ladStagesView,
      cards: ladCardsView,
      inline: ladInlineView,
      backlog: ladBacklogView,
      split: ladSplitView,
      calendar: ladCalendarView,
      dashboard: ladDashboardView,
  }),
  form: ladFullForm,
  forms: { full: ladFullForm, context: ladContextForm, mini: ladMiniForm, lookup: ladLookupForm },
  menu: ladMenu,
} as IRecordTypeDefinition;
